import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  Lookup,
  Editing,
  Selection,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import {
  AssetStatusType,
  AssetSubStatus,
  IconWithTooltip,
  DefaultDateFormat,
} from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import { Icon } from "@iconify/react/dist/iconify.js";
import Modal from "react-modal";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
} from "../../../helper/message.js";
import Swal from "sweetalert2";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi.js";
import {
  useGetCodeWiseAppModuleFeaturePermission,
  getStoredFeatureMenu,
} from "../../../helper/sessionHelper.js";
import { Loader } from "../../Shared/PageLoader";
import moment from "moment";

const statusOptions = [
  { text: "Move Asset", value: 3 },
  { text: "Send to PR SAP", value: 4 },
];

const requestActionOptions = [
  { text: "Asset Movement", value: 1 },
  { text: "Asset Purchase", value: 2 },
  { text: "Asset Hire", value: 3 },
];

export default function ApprovedAssetRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();

  const [state, setState] = useState({
    isSaveAssetModalOpen: false,
    requestId: 0,
    requestNo: "",
    remark: "",
    statusId: 0,
    subAssetsList: [],
    requestDetails: [],
    isCompleteLoading: false,
    loadingMessage: "",
    isSavingAsDraft: false,
    isSendForApproval: false,
  });

  const [assetRequestStatusDropdown, setAssetRequestStatusDropdown] = useState(
    []
  );
  const [AddrequestList, setAddrequestList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [assetData, setAssetData] = useState(null);

  const refDataGrid = useRef(null);
  const gridRef = useRef(null);
  const selectedAssets = [];

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Action On Request";
  }, []);

  let assetMovementfeaturePermission = useGetCodeWiseAppModuleFeaturePermission(
    "69186ae7-409c-4f66-82bb-fb1344441005"
  );
  let assetPurchasefeaturePermission = useGetCodeWiseAppModuleFeaturePermission(
    "31c9e394-9cab-4e47-85d3-a3824e70d1e5"
  );
  let assetHirefeaturePermission = useGetCodeWiseAppModuleFeaturePermission(
    "aea33f40-5e4c-4af9-8992-213ab1f32608"
  );
  let assetActionOnRequestfeaturePermission =
    useGetCodeWiseAppModuleFeaturePermission(
      "61f04c61-3c68-415e-ba46-5fc1a05cc4f8"
    );

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const [errors, setErrors] = useState({
    assetRequestStatusValidation: "",
  });

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      await getApprovedAssetRequestLst();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetStatusDropdown = async () => {
    try {
      const response = await assetService.getAssetStatusDropdown(
        AssetStatusType.AssetMovement
      );
      let assetRequestStatus = [];

      assetRequestStatus = response?.data.filter(
        (f) =>
          f.id === AssetSubStatus.AssetMove || f.id === AssetSubStatus.SendforPR
        // /&& f.statusId === AssetSubStatus.AssetRequestApprovalCompleted
      );
      setAssetRequestStatusDropdown(assetRequestStatus);
    } catch (error) {
      console.log(error);
    }
  };

  const getSubAssets = async () => {
    try {
      var assetRequestSubResponse = await assetService.addAssetRequestSubList(
        0,
        state?.requestId
      );

      setState((prevState) => ({
        ...prevState,
        subAssetsList: assetRequestSubResponse.data, // assuming response.data is the asset array
      }));

      console.log(assetRequestSubResponse.data);

      //setSelectionFilterKeys(assetRequestSubResponse?.data?.filter(e=>e.isSent === true));

      // let selectedAssetId = [];
      // assetRequestSubResponse?.data?.forEach(element => {
      //   if (element.isSent === true) {
      //     selectedAssetId.push(element.requestSubId);
      //   }
      // });
      // setSelectedRowKeys(selectedAssetId);
    } catch (error) {
      console.log(error);
    }
  };

  const getApprovedAssetRequestLst = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      let body = {
        requestId: 0,
        statusId: AssetSubStatus.AssetRequestApproved,
        userId: user?.userId,
      };
      const response = await assetService.getApprovedAssetRequest(body);
      //var data = response.data;
      //console.log(JSON.stringify(response.data));
      var data = response.data?.filter(
        (e) =>
          e.actionOnRequestStatusId !==
            AssetSubStatus.ActionOnRequestApproved &&
          e.actionOnRequestStatusId > 0
      );
      //console.log(JSON.stringify(response.data));
      setAddrequestList(data);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const handleInputChange = async (e, field) => {
    const value = e.value;
    // let err = { ...errors };
    // if (field === "remark") {
    //   err.subjectValidation = "";
    // }
    // Set the selected value in AssetItem first
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
    //setErrors(err);
  };

  const handleOnCloseAssetRequestStatusModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSaveAssetModalOpen: false,
        requestDetails: [],
        requestId: 0,
        requestNo: "",
        remark: "",
        statusId: 0,
        subAssetsList: [],
        isSavingAsDraft: false,
        isSendForApproval: false,
      }));

      setSelectedRowKeys([]);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidApproveData = () => {
    let isvalid = true;
    try {
      let err = { ...errors };
      err.assetRequestStatusValidation = "";
      if (state.statusId === 0) {
        err.assetRequestStatusValidation =
          "Please select asset request status.";
        isvalid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isvalid;
  };

  const checkMovementWorkFlow = async () => {
    try {
      //#region [Check movement workflow]
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetMovementfeaturePermission?.featureId,
        projectId: assetData?.projectId,
        departmentId: assetData?.departmentId,
      };

      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );

      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetMovementfeaturePermission?.featureId,
        workflowCategoryId,
        assetData?.projectId,
        assetData?.departmentId
      );

      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset movement!!`);
        return false;
      }
      //#endregion
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const checkPurchaseWorkFlow = async (e) => {
    try {
      //#region [Check asset purchase workflow]
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetPurchasefeaturePermission?.featureId,
        projectId: assetData?.projectId,
        departmentId: assetData?.departmentId,
      };

      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetPurchasefeaturePermission?.featureId,
        workflowCategoryId,
        assetData?.projectId,
        assetData?.departmentId
      );

      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset purchase!!`);
        return false;
      }
      //#endregion
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const checkHireWorkFlow = async (e) => {
    try {
      //#region [Check asset hire workflow]
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetHirefeaturePermission?.featureId,
        projectId: assetData?.projectId,
        departmentId: assetData?.departmentId,
      };

      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetHirefeaturePermission?.featureId,
        workflowCategoryId,
        assetData?.projectId,
        assetData?.departmentId
      );

      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this asset hire!!`);
        return false;
      }
      //#endregion
    } catch (error) {
      console.log(error);
    }
    return true;
  };

  const handleOnSaveAsDraftActionOnRequest = async (e) => {
    try {
      //#region [To check action on request workflow]
      setState((prev) => ({
        ...prev,
        isSavingAsDraft: true,
      }));
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetActionOnRequestfeaturePermission?.featureId,
        projectId: assetData.projectId,
        departmentId: assetData.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetActionOnRequestfeaturePermission?.featureId,
        workflowCategoryId,
        assetData.projectId,
        assetData.departmentId
      );
      //#endregion
      
      //const updatedRows = gridRef.current?.instance.getDataSource();
      const updatedData = state.subAssetsList; //updatedRows?._items;
      const allSelectedData = updatedData?.filter((e) => e.requestTypeId === 0);

      if (allSelectedData.length === updatedData.length) {
        await showErrorMessage(`Please set action for asset(s) !!`);
        setState((prev) => ({
          ...prev,
          isSavingAsDraft: false,
          isSendForApproval: false,
        }));
        return;
      }

      //const actionStatusId = allSelectedData.length === 0 ? AssetSubStatus.ActionOnRequestSentForApproval : AssetSubStatus.ActionPartiallyApproved;
      //console.log(updatedData._items);

      let selectedAssetRows = [];

      for (let i = 0; i < updatedData.length; i++) {
        const row = updatedData[i];
        if (row.requestTypeId > 0) {
          //#region [To check workflow as per request type]
          if (row.requestTypeId === 1) {
            if ((await checkMovementWorkFlow()) === false) {
              return;
            }
          } else if (row.requestTypeId === 2) {
            if ((await checkPurchaseWorkFlow()) === false) {
              return;
            }
          } else if (row.requestTypeId === 3) {
            if ((await checkHireWorkFlow()) === false) {
              return;
            }
          }
          //#endregion
          selectedAssetRows.push({
            assetRequestSubId: row.requestSubId,
            requestTypeId: row.requestTypeId,
          });
        }
      }

      let body = {
        assetRequestId: state?.requestId,
        workFlowId: workflowData.id,
        userId: user?.userId,
        assetActionStatusId: AssetSubStatus.ActionOnRequestInDraftMode,
        UpdatedAssetRequestSubData: selectedAssetRows,
      };

      const response = await assetService.updateActionAssetRequestSub(body);
      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({
          ...prev,
          isSavingAsDraft: false,
          isSaveAssetModalOpen: false,
        }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        let selectedAssetId = [];
        setState((prev) => ({
          ...prev,
          isSavingAsDraft: false,
          isSaveAssetModalOpen: false,
        }));
        // setSelectedRowKeys(selectedAssetId);
        setTimeout(async () => {
          await getApprovedAssetRequestLst();
        }, 0);
        setTimeout(async () => {
          await getSubAssets();
        }, 0);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnSendforApprovalActionOnRequest = async (e) => {
    try {
      setState((prev) => ({
        ...prev,
        isSendForApproval: true,
      }));
      let workflowCategoryId = 0;
      const updatedRows = gridRef.current?.instance.getDataSource();
      const updatedData = updatedRows?._items;
      const allSelectedData = updatedData?.filter((e) => e.requestTypeId === 0);

      if (allSelectedData.length > 0) {
        await showErrorMessage(`Please set action for asset(s) !!`);
        setState((prev) => ({
          ...prev,
          isSavingAsDraft: false,
          isSendForApproval: false,
        }));
        return;
      }

      // if (allSelectedData.length === updatedData.length) {
      //   await showErrorMessage(`Please set action for asset(s) !!`);
      //   return;
      // }

      let categorybody = {
        formId: assetActionOnRequestfeaturePermission?.featureId,
        projectId: assetData.projectId,
        departmentId: assetData.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetActionOnRequestfeaturePermission?.featureId,
        workflowCategoryId,
        assetData.projectId,
        assetData.departmentId
      );

      const actionStatusId = AssetSubStatus.ActionOnRequestSentForApproval;
      //console.log(updatedData._items);

      let workflowCategory = {};
      workflowCategory.formId =
        assetActionOnRequestfeaturePermission?.featureId;
      workflowCategory.categoryId = workflowCategoryId;
      workflowCategory.projectId = assetData?.projectId;
      workflowCategory.departmentId = assetData?.departmentId;

      let selectedAssetRows = [];
      updatedData?.forEach((row, index) => {
        if (row.requestTypeId > 0) {
          var selectedRow = {};
          selectedRow.assetRequestSubId = row.requestSubId;
          selectedRow.requestTypeId = row.requestTypeId;
          selectedAssetRows.push(selectedRow);
        }
      });

      let body = {
        assetRequestId: state?.requestId,
        remark: "",
        userId: user?.userId,
        assetActionStatusId: AssetSubStatus.ActionOnRequestApproved,
        isSentForApproval: true,
      };

      const response = await assetService.updateActionAssetRequestSubStatus(
        body
      );

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({
          ...prev,
          isSendForApproval: false,
          isSaveAssetModalOpen: false,
        }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        setState((prev) => ({
          ...prev,
          isSendForApproval: false,
          isSaveAssetModalOpen: false,
        }));
        let selectedAssetId = [];
        setSelectedRowKeys(selectedAssetId);
        setTimeout(async () => {
          await getApprovedAssetRequestLst();
        }, 0);
        setTimeout(async () => {
          await getSubAssets();
        }, 0);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnMoveAssetRequestToMovement = async (e) => {
    e.preventDefault();
    try {
      let workflowCategoryId = 0;
      let categorybody = {
        formId: assetMovementfeaturePermission?.featureId,
        projectId: state.requestDetails.projectId,
        departmentId: state.requestDetails.departmentId,
      };
      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        assetMovementfeaturePermission?.featureId,
        workflowCategoryId,
        state.requestDetails.projectId,
        state.requestDetails.departmentId
      );
      //console.log(JSON.stringify(workflowData));

      const stagesWithApprovers = workflowData?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.map((stage) => ({
          actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
          approvers: stage?.approvers,
        }));
      const Approvers = workflowData?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.flatMap((stage) =>
          stage?.approvers?.map((approver) => ({
            actionTypeId: stage?.actionTypeId,
            userId: approver?.userId,
            canEdit: approver?.canEdit,
            stageId: stage?.index,
          }))
        );

      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }

      if (selectedRowKeys.length === 0) {
        return;
      }

      let confirmationQuestion = `Do you want to approve selected asset request?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) return;

      let workflowCategory = {};
      workflowCategory.formId = assetMovementfeaturePermission?.featureId;
      workflowCategory.categoryId = workflowCategoryId;
      workflowCategory.projectId = state.requestDetails.projectId;
      workflowCategory.departmentId = state.requestDetails.departmentId; // user.userDepartmentId;

      setState((prev) => ({ ...prev, isSavingAsDraft: true }));

      let body = {
        applicationId: 3,
        assetRequestId: state.requestId,
        statusId: AssetSubStatus.AssetMovementInDraftMode,
        remark: state.remark,
        userId: user?.userId,
        assetId: selectedRowKeys,
        departmentId: workflowData.departmentId,
        WorkflowId: workflowData.id,
        formName: assetActionOnRequestfeaturePermission?.featureName,
        formId: assetMovementfeaturePermission?.featureId,
        isLoginUserRequester: Approvers?.[0]?.actionTypeId === 8 ? false : true,
        WorkflowCategoryRequest: workflowCategory,
      };

      const response = await assetService.moveAssetRequestToMovement(body);
      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        let selectedAssetId = [];
        setSelectedRowKeys(selectedAssetId);
        setTimeout(async () => {
          await getApprovedAssetRequestLst();
        }, 0);
        setTimeout(async () => {
          await getSubAssets();
        }, 0);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    }
  };

  const handleOnMoveAssetRequestToPurchase = async (e) => {
    e.preventDefault();
    try {
      //if (isValidApproveData())
      if (selectedRowKeys.length === 0) {
        return;
      }
      let confirmationQuestion = `Do you want to approve selected asset request?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) return;
      // let selectedAssetId = [];
      // selectedRowKeys.forEach(element => {
      //   selectedAssetId.push(element.requestSubId);
      // });

      setState((prev) => ({ ...prev, isSavingAsDraft: true }));

      let body = {
        assetRequestId: state.requestId,
        statusId: AssetSubStatus.SendforPR,
        remark: state.remark,
        userId: user?.userId,
        assetId: selectedRowKeys,
      };

      const response = await assetService.moveAssetRequestToPurchase(body);
      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        //window.location.href = `/ApprovedAssetRequest`;
        let selectedAssetId = [];
        setSelectedRowKeys(selectedAssetId);
        setTimeout(async () => {
          await getApprovedAssetRequestLst();
        }, 0);
        setTimeout(async () => {
          await getSubAssets();
        }, 0);

        setState((prev) => ({
          ...prev,
          isSaveAssetModalOpen: false,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    }
  };

  const GetWorkFlowForApprovers = async (
    formId,
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: formId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      // if (
      //   body.formId > 0 &&
      //   body.categoryId > 0 &&
      //   body.projectId > 0 &&
      //   body.departmentId > 0
      // )
      {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        return response;
        //console.log(JSON.stringify(response));
        // setWorkflowData(response);
        // const stagesWithApprovers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.map((stage) => ({
        //     actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
        //     approvers: stage?.approvers,
        //   }));
        // const Approvers = response?.stages
        //   ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        //   ?.flatMap((stage) =>
        //     stage?.approvers?.map((approver) => ({
        //       actionTypeId: stage?.actionTypeId,
        //       userId: approver?.userId,
        //       canEdit: approver?.canEdit,
        //       stageId: stage?.index,
        //     }))
        //   );
        // setAssetRequestApprovers(Approvers);
        // setAssetRequestApproversByWorkflow(stagesWithApprovers);
      }
      // console.log(Approvers);
    } catch (error) {
      console.log("Error getWorkFlowForApprovers===>", error);
    }
  };

  const handleOnMoveAssetRequestToQuotation = async (e, quotationTypeId) => {
    e.preventDefault();
    try {
      let workflowCategoryId = 0;
      let categorybody = {
        formId:
          quotationTypeId === 1
            ? assetPurchasefeaturePermission?.featureId
            : assetHirefeaturePermission?.featureId,
        projectId: state.requestDetails.projectId,
        departmentId: state.requestDetails.departmentId,
      };

      const categoryresponse = await assetService.getWorkflowGroup(
        categorybody
      );
      if (categoryresponse?.data.length >= 1) {
        workflowCategoryId = categoryresponse?.data[0].workflowCategoryId;
      }

      let workflowData = await GetWorkFlowForApprovers(
        quotationTypeId === 1
          ? assetPurchasefeaturePermission?.featureId
          : assetHirefeaturePermission?.featureId,
        workflowCategoryId,
        state.requestDetails.projectId,
        state.requestDetails.departmentId
      );

      const stagesWithApprovers = workflowData?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.map((stage) => ({
          actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
          approvers: stage?.approvers,
        }));
      const Approvers = workflowData?.stages
        ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
        ?.flatMap((stage) =>
          stage?.approvers?.map((approver) => ({
            actionTypeId: stage?.actionTypeId,
            userId: approver?.userId,
            canEdit: approver?.canEdit,
            stageId: stage?.index,
          }))
        );

      if (workflowData === null || workflowData === undefined) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }

      if (selectedRowKeys.length === 0) {
        return;
      }
      let confirmationQuestion = `${
        quotationTypeId === 1
          ? `<span style='font-size:16px;'>Do you want to send this request to Asset Purchase?</span>`
          : `<span style='font-size:16px;'>Do you want to send this request to Asset Hire?</span>`
      }`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) return;
      // let selectedAssetId = [];
      // selectedRowKeys.forEach(element => {
      //   selectedAssetId.push(element.requestSubId);
      // });

      let workflowCategory = {};
      workflowCategory.formId =
        quotationTypeId === 1
          ? assetPurchasefeaturePermission?.featureId
          : assetHirefeaturePermission?.featureId;
      workflowCategory.categoryId = workflowCategoryId;
      workflowCategory.projectId = state.requestDetails.projectId;
      workflowCategory.departmentId = state.requestDetails.departmentId;

      setState((prev) => ({ ...prev, isSavingAsDraft: true }));
      let body = {
        applicationId: 3,
        assetRequestId: state.requestId,
        statusId:
          quotationTypeId === 1
            ? AssetSubStatus.RequestForAssetPurchaseInDraftMode
            : AssetSubStatus.RequestForAssetServiceOrderInDraftMode,
        remark: state.remark,
        userId: user?.userId,
        assetId: selectedRowKeys,
        quotationTypeId: quotationTypeId,
        departmentId: workflowData.departmentId,
        WorkflowId: workflowData.id,
        formName:
          quotationTypeId === 1
            ? assetPurchasefeaturePermission?.featureName
            : assetHirefeaturePermission?.featureName,
        formId:
          quotationTypeId === 1
            ? assetPurchasefeaturePermission?.featureId
            : assetHirefeaturePermission?.featureId,
        isLoginUserRequester: Approvers?.[0]?.actionTypeId === 8 ? false : true,
        WorkflowCategoryRequest: workflowCategory,
        purchaseStatusId:
          quotationTypeId === 1
            ? AssetSubStatus.AssetPurchaseRequestDrafted
            : AssetSubStatus.RequestForAssetPurchaseInDraftMode,
      };

      const response = await assetService.moveAssetRequestToQuotation(body);
      //const response = await assetService.moveAssetRequestToAsetPurchase(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        let selectedAssetId = [];
        setSelectedRowKeys(selectedAssetId);
        setTimeout(async () => {
          await getApprovedAssetRequestLst();
        }, 0);
        setTimeout(async () => {
          await getSubAssets();
        }, 0);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    }
  };

  const onSelectionChanged = useCallback(
    ({ selectedRowKeys: changedRowKeys }) => {
      setSelectedRowKeys(changedRowKeys);
    },
    []
  );

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AddrequestList}
              ref={refDataGrid}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  // {
                  //   location: "before",
                  //   template: "toolbarAddTemplate",
                  // },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getMovementRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestId"
                caption=""
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                allowExporting={false}
                width={95}
                cellRender={(data) => {
                  const rowData = data?.data;
                  const idPrefix = `icon-${rowData?.requestId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/asset-action-preview", {
                                    state: {
                                      requestId: data?.data?.requestId,
                                      sourceUrl: "ApprovedAssetRequest",
                                    },
                                  })
                                }
                              />
                            </span>
                          </>
                        )}
                        &nbsp;
                        {/* {data.data.statusId ===
                          AssetSubStatus.AssetRequestApproved &&
                          data.data.toId === user.userId && ( */}
                        {/* {data.data.statusId ===
                          AssetSubStatus.AssetRequestApproved && ( */}
                        <>
                          <span>
                            {/* <IconWithTooltip
                                id={`${idPrefix}-approve`}
                                className="iconify-size mr-1"
                                title="Approve"
                                tooltip="Approve"
                                icon="lets-icons:check-fill"
                                style={{
                                  cursor: "pointer",
                                  width: "20",
                                  height: "20",
                                }}
                                onClick={() => {
                                  setState((prev) => ({
                                    ...prev,
                                    requestId: data?.data?.requestId,
                                    requestNo: data?.data?.requestNo,
                                    isSaveAssetModalOpen: true,
                                  }));
                                }}
                              /> */}
                            {data.data.actionAllowed && (
                              //rowData.fromId === user.userId &&
                              //rowData.departmentId === user?.userDepartmentId &&

                              <>
                                <button
                                  style={{ cursor: "pointer" }}
                                  type="button"
                                  title="Action"
                                  className="btn btn-primary btn-sm-1"
                                  onClick={() => {
                                    //setAssetData(data?.data);
                                    // setState((prev) => ({
                                    //   ...prev,
                                    //   requestId: data?.data?.requestId,
                                    //   requestNo: data?.data?.requestNo,
                                    //   isSaveAssetModalOpen: true,
                                    //   requestDetails: data?.data,
                                    // }));
                                    navigate("/UpdateActionOnRequest", {
                                      state: {
                                        requestId: data?.data?.requestId,
                                        sourceUrl: "ActionOnRequest",
                                        isReport: false,
                                        requestDetails: data?.data,
                                      },
                                    });
                                  }}
                                >
                                  <Icon
                                    className="iconify-size mr-1"
                                    icon="mdi:call-to-action"
                                    width="14"
                                    height="14"
                                  />
                                  &nbsp;Action
                                </button>
                              </>
                            )}
                          </span>
                        </>
                        {/* )} */}
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="requestNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="approvalStatusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestPending
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestInDraftMode
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestSentForApproval
                  )
                    color = "#FF9800";
                  else if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestRecall
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.actionOnRequestStatusId ===
                    AssetSubStatus.ActionOnRequestBackToDraft
                  )
                    color = "#ee0a0aff";

                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedOn) {
                    lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                  }
                  else {
                    const parsedDate = new Date(e?.data?.updatedOn);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    else {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                  }
                  return (
                    <div>
                      <span style={{ color }}>
                        {e.data?.actionOnRequestStatus}
                      </span>
                      {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromName}
                      </div> */}
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
                cellRender={(data) => {
                  if (data?.data?.updatedOn) {
                    return (
                      <>
                        <span>{moment(data?.data?.requestedDate)
                          .format(DefaultDateFormat.MomentMonthYearDateFormat)
                          .toString() ?? "" ?? ""}</span>
                        {/* <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {moment(data?.data?.updatedOn)
                            .format(DefaultDateFormat.MomentDisplayDateTimeFullFormat)
                            .toString() ?? ""}
                        </div> */}
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowSorting={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowSorting={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="projectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.projectName ?? ""}</span>
                      {data?.data?.locationName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.locationName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="requestSubject"
                caption="Subject"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="requestTypeName"
                caption="Request Type"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="locationName"
                caption="Location"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="requestedCount"
                caption="No Of Assets"
                allowSearch={true}
                allowFiltering={false}
                alignment={"center"}
                allowSorting={true}
              /> */}
              {/* <Column
                dataField="note"
                caption="Note"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="remark"
                caption="Remark"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetStatus"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add Movement Request"
                        className="btn btn-primary btn-sm mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          try {
                            navigate("/AddAssetRequest");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <span title="Add Movement Request">
                          <i className="fas fa-plus"></i>
                          &nbsp;&nbsp;Add
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getApprovedAssetRequestLst();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Approved Asset Request" />
            </DataGrid>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isSaveAssetModalOpen}
        className={"react-modal custom-modal-large-2"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Asset Request Status Update Modal"
        onAfterOpen={async () => {
          await getSubAssets();
          await getAssetStatusDropdown();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Update Asset Status For [` + state.requestNo + `]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAssetRequestStatusModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  <span>
                    <small>
                      From
                      <br />
                      <b>{state.requestDetails?.fromDepartment}</b>
                    </small>
                  </span>
                </label>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  <span>
                    <small>
                      Date
                      <br />
                      <b>
                        {state.requestDetails?.requestedDate
                          ? new Date(
                              state.requestDetails?.requestedDate
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                          : ""}
                      </b>
                    </small>
                  </span>
                </label>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  <span>
                    <small>
                      Project
                      <br />
                      <b>
                        {state.requestDetails?.projectName
                          ? state.requestDetails?.projectName
                          : "-"}
                      </b>
                    </small>
                  </span>
                </label>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="form-group mb-2">
                <label>
                  <span>
                    <small>
                      Subject
                      <br />
                      <b>
                        {state.requestDetails?.requestSubject
                          ? state.requestDetails?.requestSubject
                          : "-"}
                      </b>
                    </small>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <DataGrid
              ref={gridRef}
              dataSource={state.subAssetsList}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              //onSelectionChanged={onSelectionChanged}
              onSelectionChanged={(e) => {
                setSelectedRowKeys(e.selectedRowKeys);
                setSelectedRowData(e.selectedRowsData);
              }}
              selectedRowKeys={selectedRowKeys}
              keyExpr="requestSubId"
              // onRowPrepared={(e) => {
              //   if (e.rowType === "data") {
              //     if (e.data?.isSent === true)
              //       {
              //       // e.rowElement.cells[0].hidden = true;
              //       e.rowElement.cells[0].style.visibility = "hidden";
              //     }
              //   }
              // }}
              onCellValueChanged={(e) => {
                if (e.column.dataField === "requestTypeId") {
                  const newValue = e.value;
                  // Filter rows matching the new dropdown value
                  const matchingKeys = state.subAssetsList
                    .filter((item) => item.requestTypeId === newValue)
                    .map((item) => item.requestSubId);

                  setSelectedRowKeys(matchingKeys);
                  selectedAssets.push(matchingKeys);
                }
              }}
              onCellPrepared={(e) => {
                if (
                  e.rowType === "data" &&
                  e.column.dataField === "requestTypeId"
                ) {
                  // Example: highlight based on value
                  if (e.data.requestTypeId === 1) {
                    e.cellElement.style.backgroundColor = "#d1ffd1"; // light green
                  } else if (e.data.requestTypeId === 2) {
                    e.cellElement.style.backgroundColor = "#ffe0e0"; // light red
                  } else {
                    e.cellElement.style.backgroundColor = "#f0f0f0"; // neutral gray
                  }
                }
              }}

              //#region
              // onEditorPreparing={(e) => {
              //   if (e.dataField === "requestTypeId" && e.parentType === "dataRow") {
              //     e.editorOptions.onValueChanged = (args) => {
              //       const selectedValue = args.value;
              //       console.log("Selected value in grid dropdown:", selectedValue);

              //       debugger;
              //       // Optional: update selection or trigger logic
              //       const matchingKeys = state.subAssetsList
              //         .filter((item) => item.requestTypeId === selectedValue)
              //         .map((item) => item.requestSubId);

              //       setSelectedRowKeys(selectedValue);
              //       selectedAssets.push(selectedValue);
              //     };
              //   }
              // }}

              // onEditorPreparing={(e) => {
              //   if (e.dataField === "requestTypeId" && e.parentType === "dataRow") {
              //     e.editorOptions.onValueChanged = (args) => {
              //       debugger;
              //       //setSelectedRowKeys.push(args.value);
              //       selectedAssets.push(args.value);
              //       //console.log("Dropdown changed to:", args.value);
              //     };
              //   }
              // }}

              //onRowPrepared={}
              //defaultSelectionFilter={selectionFilterKeys}
              //#endregion
            >
              <Editing mode="cell" allowUpdating={true} />
              {/* <Selection
                key="isSent"
                mode="multiple"
                selectAllMode={"allPages"}
                showCheckBoxesMode={"always"}
                //deferred={true}
              /> */}
              {/* <FilterRow visible={true} /> */}
              <Column
                dataField="categoryName"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                allowEditing={false}
              />
              <Column
                dataField="requiredQty"
                caption="Req. Qty"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                allowEditing={false}
              />
              <Column
                dataField="requirementDate"
                caption="Date of Requirement"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
                allowEditing={false}
              />
              <Column dataField="requestTypeId" caption="Action" width={250}>
                <Lookup
                  dataSource={requestActionOptions}
                  valueExpr="value"
                  displayExpr="text"
                />
              </Column>
              <Column
                dataField="purpose"
                caption="Purpose"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                allowEditing={false}
              />
              <Column
                dataField="requestNo"
                caption="Asset No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                allowEditing={false}
              />
              <Column
                dataField="assetStatus"
                caption="Action Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                allowEditing={false}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={false}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={false} />
              <Export enabled={false} fileName="SubAssetList" />
            </DataGrid>
          </div>
          {/* <div className="row">
            <div className="col-12 col-lg-5">
              <div className="form-group mb-2">
                <label>
                  Status<span className="text-danger"></span>
                </label>
                <SelectBox
                  dataSource={assetRequestStatusDropdown}
                  className="form-control"
                  classNamePrefix="select"
                  placeholder="Select Asset Request Status"
                  name="assetRequestStatusDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.statusId}
                  defaultValue={state.id}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.assetRequestStatusValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      statusId: e?.selectedItem?.id ?? 0,
                    }));
                  }}
                />
                {errors.assetRequestStatusValidation && (
                  <div className="text-danger">
                    {errors.assetRequestStatusValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-7">
              <div className="form-group mb-2">
                <label>
                  Reason<span className="text-danger"></span>
                </label>
                <TextBox
                  className="form-control"
                  placeholder="Enter Remark"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  allowEditing={false}
                  value={state.remark}
                  onValueChanged={(e) => handleInputChange(e, "remark")}
                />
              </div>
            </div>
          </div> */}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAssetRequestStatusModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
          &nbsp;
          {state.requestDetails?.stageApproved === false && (
            <>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                title="Cancel"
                onClick={() => {
                  handleOnSaveAsDraftActionOnRequest();
                }}
                disabled={state.isSendForApproval}
              >
                <i
                  className={`fas fa-${
                    state.isSavingAsDraft ? `spinner fa-spin` : `file-signature`
                  }`}
                ></i>
                &nbsp;&nbsp;Save as Draft
                {/* <i className="fas fa-file-signature"></i>&nbsp;&nbsp;Save as Draft */}
              </button>
              &nbsp;
            </>
          )}
          {state.requestDetails?.stageApproved === false &&
            (state.requestDetails?.actionOnRequestStatusId ===
              AssetSubStatus.ActionOnRequestInDraftMode ||
              state.requestDetails?.actionOnRequestStatusId ===
                AssetSubStatus.ActionOnRequestBackToDraft ||
              state.requestDetails?.actionOnRequestStatusId ===
                AssetSubStatus.ActionOnRequestRecall) && (
              <>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  title="Cancel"
                  onClick={() => {
                    handleOnSendforApprovalActionOnRequest();
                  }}
                  disabled={state.isSavingAsDraft}
                >
                  <i
                    className={`fas fa-${
                      state.isSendForApproval ? `spinner fa-spin` : `check`
                    }`}
                  ></i>
                  &nbsp;&nbsp;Send for Approval
                  {/* <i className="fas fa-check"></i>&nbsp;&nbsp;Send for Approval */}
                </button>
              </>
            )}
          {/* {(state.requestDetails?.statusId ===
            AssetSubStatus.AssetRequestApproved ||
            state.requestDetails?.statusId === AssetSubStatus.AssetMovement ||
            state.requestDetails?.statusId === AssetSubStatus.AssetPR ||
            state.requestDetails?.statusId ===
              AssetSubStatus.AssetRequestPartiallyComlpeted) && (
            <>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={async (e) => {
                  await handleOnMoveAssetRequestToMovement(e);
                }}
              >
                <span title="Submit">
                  <i
                    className={`fas fa-${
                      state.isAssetSubmitted ? "spinner fa-spin" : "check"
                    }`}
                  />
                  &nbsp;&nbsp;Send for Asset Movement
                </span>
              </button>
            </>
          )}

          {(state.requestDetails?.statusId ===
            AssetSubStatus.AssetRequestApproved ||
            state.requestDetails?.statusId === AssetSubStatus.AssetMovement ||
            state.requestDetails?.statusId === AssetSubStatus.AssetPR ||
            state.requestDetails?.statusId ===
              AssetSubStatus.AssetRequestPartiallyComlpeted) && (
            <>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={async (e) => {
                  //await handleOnMoveAssetRequestToPurchase(e);
                  await handleOnMoveAssetRequestToQuotation(
                    e,
                    AssetQuotationType.RequestForAssetPurchase
                  );
                }}
              >
                <span title="Submit">
                  <i
                    className={`fas fa-${
                      state.isAssetSubmitted ? "spinner fa-spin" : "check"
                    }`}
                  />
                  &nbsp;&nbsp;Send for Purchase
                </span>
              </button>
            </>
          )}

          {(state.requestDetails?.statusId ===
            AssetSubStatus.AssetRequestApproved ||
            state.requestDetails?.statusId === AssetSubStatus.AssetMovement ||
            state.requestDetails?.statusId === AssetSubStatus.AssetPR ||
            state.requestDetails?.statusId ===
              AssetSubStatus.AssetRequestPartiallyComlpeted) && (
            <>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={async (e) => {
                  //await handleOnMoveAssetRequestToPurchase(e);
                  await handleOnMoveAssetRequestToQuotation(
                    e,
                    AssetQuotationType.RequestForAssetServiceOrder
                  );
                }}
              >
                <span title="Submit">
                  <i
                    className={`fas fa-${
                      state.isAssetSubmitted ? "spinner fa-spin" : "check"
                    }`}
                  />
                  &nbsp;&nbsp;Send for Hire
                </span>
              </button>
            </>
          )} */}
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
